module.exports = __webpack_public_path__ + "mr.svg?a8f6d9d85c3bae4029bf733c4e29dc08";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/mr.svg
// module id = 1077
// module chunks = 27